import React, { useEffect, useState } from "react";
import { MapPin, Phone, Mail, MessageCircle, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export default function ContactPage() {
  const { t } = useLang();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(({ data }) => setS(data)).catch(() => {}); }, []);
  const wa = s?.whatsapp || "9825708561";

  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-16">
      <div className="text-center mb-12">
        <span className="text-xs tracking-[0.2em] uppercase text-gold">{t("nav_contact")}</span>
        <h1 className="font-display text-4xl sm:text-5xl text-zinc-900 mt-3">{t("contact_title")}</h1>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          {[
            { icon: MapPin, label: t("address"), value: "6th Floor, Premier House, Sarkhej-Gandhinagar Highway, Bodakdev, Ahmedabad, Gujarat" },
            { icon: Phone, label: t("phone"), value: wa, href: `tel:${wa}` },
            { icon: Mail, label: t("email"), value: s?.email, href: `mailto:${s?.email}` },
            { icon: Clock, label: "Hours", value: "Mon – Sun, 9:00 AM – 9:00 PM" },
          ].map((c, i) => (
            <div key={i} className="flex gap-4 bg-card border border-pink-200 rounded-2xl p-5">
              <div className="h-11 w-11 rounded-xl gold-gradient flex items-center justify-center shrink-0"><c.icon size={20} className="text-black" /></div>
              <div>
                <span className="text-xs tracking-wider uppercase text-zinc-500">{c.label}</span>
                {c.href ? <a href={c.href} className="block text-zinc-900 hover:text-gold mt-0.5">{c.value}</a> : <p className="text-zinc-900 mt-0.5">{c.value}</p>}
              </div>
            </div>
          ))}
          <a href={`https://wa.me/91${wa}`} target="_blank" rel="noreferrer" data-testid="whatsapp-btn">
            <Button className="w-full bg-[#25D366] hover:bg-[#1eb855] text-black font-semibold rounded-full h-12"><MessageCircle size={18} className="mr-2" /> {t("whatsapp_us")}</Button>
          </a>
        </div>

        <div className="rounded-2xl overflow-hidden border border-pink-200 min-h-[400px]">
          <iframe
            title="Metrix Location"
            src="https://www.google.com/maps?q=Premier%20House%20SG%20Highway%20Bodakdev%20Ahmedabad&output=embed"
            className="w-full h-full min-h-[400px]"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
